import "./plugins/vant";
// https://vant-contrib.gitee.io/vant/next/#/zh-CN

import Vue from "vue";
import qs from "qs";
// eslint-disable-next-line
import vueMiniPlayer from "vue-mini-player";
import { Checkbox, CheckboxGroup } from "vant";
import ElementUI from "element-ui";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import "./icons";
import "./rem.js";

import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/public.css";
import "./assets/css/font.css";
import "./assets/js/weiXinShare";
import "./assets/scss/global.scss";
// eslint-disable-next-line
import "vue-mini-player/lib/vue-mini-player.css";
// import vConsole from "./assets/js/vconsole.js";

Vue.use(ElementUI);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(vueMiniPlayer);
// "vue-mini-player": "^0.2.1"
// Vue.prototype.vConsole = vConsole;
Vue.config.productionTip = false;
Vue.prototype.$qs = qs;
Vue.config.ignoredElements = ["wx-open-launch-weapp"];

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#nxin");
